/* eslint-disable no-param-reassign */

// @ts-nocheck
let count = 0;
function noop() {}

function jsonp(url, opts, fn) {
    if (typeof opts === 'function') {
        fn = opts;
        opts = {};
    }
    if (!opts) {
        opts = {};
    }

    const id = opts.name || `jsonp_cb_${count++}`;
    const param = opts.param || 'callback'; // 回调函数参数名
    const timeout = opts.timeout == null ? 60000 : opts.timeout;
    const enc = encodeURIComponent;
    const target = document.getElementsByTagName('script')[0] || document.head;
    let script;
    let timer;

    if (timeout) {
        timer = setTimeout(() => {
            // eslint-disable-next-line no-use-before-define
            cleanup();
            if (fn) {
                fn(new Error(`jsonp timeout url:${url}`));
            }
        }, timeout);
    }

    function cleanup() {
        if (script && script.parentNode) {
            script.parentNode.removeChild(script);
        }
        window[id] = noop;
        if (timeout) {
            clearTimeout(timer);
        }
    }

    function cancel() {
        if (window[id]) {
            cleanup();
        }
    }

    window[id] = data => {
        cleanup();
        if (fn) {
            // 成功
            fn(null, data);
        }
    };
    url += `${(url.indexOf('?') > -1 ? '&' : '?') + param}=${enc(id)}`;
    url = url.replace('?&', '?');
    script = document.createElement('script');
    script.src = url;
    target.parentNode.insertBefore(script, target);

    return cancel;
}

/* eslint-disable */
const wxTmpl =
    '<div class="share-mask wx-share-mask">\
<img src="https://g1.dfcfw.com/g4/202007/20200710143417.png">\
</div>';
const wapTmpl =
    '<div class="share-mask wap-share-mask">\
<img src="data:image/png;base64,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">\
</div>';
// 默认配置
const defaultOptions = {
    channels: ['wechat', 'moment', 'qzone', 'weibo'],
    pageShare: true,
    shareData: {
        title: document.title,
        desc:
            document.querySelector('meta[name=description]') &&
            document.querySelector('meta[name=description]').getAttribute('content'),
        link: window.location.href,
        imgUrl: 'https://emfed.eastmoney.com/public/resource/img/wechatlogo.png',
        from: '东方财富移动版',
        fail(res) {
            alert(JSON.stringify(res));
        }
    },
    custom: {
        wechat: {},
        moment: {},
        qzone: {},
        weibo: {}
    }
};
const qqapi = '//open.mobile.qq.com/sdk/qqapi.js';
class Share {
    constructor(options = {}) {
        window.wxSDKJSLoaded = window.wxSDKJSLoaded || false;
        window.wxAPIData = window.wxAPIData || null;
        window.wxPageShareData = window.wxPageShareData || null;
        this.options = Object.assign(defaultOptions, options);
        this.channels = this.options.channels;

        this._config();
    }

    // qq空间分享
    qzone(shareData) {
        let url = `http://qzs.qzone.qq.com/open/connect/widget/mobile/qzshare/index.html?url=${encodeURIComponent(
            shareData.link
        )}&appkey=801004939`;
        if (shareData.title) {
            url += `&title=${encodeURIComponent(shareData.title)}`;
        }
        if (shareData.desc) {
            url += `&desc=${encodeURIComponent(shareData.desc)}`;
        }
        if (shareData.imgUrl) {
            url += `&imageUrl=${encodeURIComponent(shareData.imgUrl)}`;
        }
        if (shareData.from) {
            url += `&source=${encodeURIComponent(shareData.from)}`;
        }
        url += `&site=${encodeURIComponent('http://wap.eastmoney.com')}`;

        window.location = url;
        return false;
    }

    // 微博分享
    weibo(shareData) {
        let url = `http://service.weibo.com/share/mobile.php?url=${encodeURIComponent(
            shareData.link
        )}&appkey=3050999700`;
        if (shareData.title) {
            url += `&title=${encodeURIComponent(shareData.title)}`;
        }
        if (shareData.imgUrl) {
            url += `&pic=${encodeURIComponent(shareData.imgUrl)}`;
        }
        if (shareData.from) {
            url += `&source=${encodeURIComponent(shareData.from)}`;
        }
        url += `&sourceUrl=${encodeURIComponent('http://wap.eastmoney.com')}`;

        window.location = url;
        return false;
    }

    shareTo(channel) {
        console.log('分享到', channel);
        const shareData = this._getShareData(channel);
        if (['wechat', 'moment'].indexOf(channel) != -1) {
            if (/MicroMessenger/i.test(navigator.userAgent)) {
                // 微信浏览器
                this._wechatShareSetting(shareData);
                this._appendBrowserView('wx');
            } else {
                // 普通浏览器
                this._appendBrowserView('wap');
            }
        } else {
            this[channel] && this[channel](shareData);
        }
    }
    /**
     *
     * @param {'wx'|'wap'} type
     */
    _appendBrowserView(type = 'wx') {
        const viewMap = {
            wx: wxTmpl,
            wap: wapTmpl
        };
        const tpl = viewMap[type] || wapTmpl;
        let element = document.getElementById('emShare' + type);
        if (!element) {
            element = document.createElement('div');
            element.innerHTML = tpl;
            element.setAttribute('id', 'emShare' + type);
        }
        document.body.appendChild(element);

        let onClick = e => {
            e.stopPropagation();
            e.preventDefault();
            element.removeEventListener('click', onClick);
            document.body.removeChild(element);
        };
        element.addEventListener('click', onClick);
    }

    _getShareData(channel) {
        let opt =
            (channel && this.options.custom[channel]) ||
            this.options.custom.wechat ||
            this.options.custom.moment;
        return Object.assign({}, this.options.shareData, opt);
    }

    _config() {
        const useWechat =
            this.channels.filter(item => {
                return ['wechat', 'moment'].indexOf(item) >= 0;
            }).length > 0;

        if (useWechat) {
            if (this.options.pageShare) {
                if (window.wxPageShareData) {
                    // 已经设置过分享的数据
                    console.log('has set share data');
                } else {
                    const shareData = this._getShareData();
                    window.wxPageShareData = shareData;
                    console.log('初始化配置');
                    // 初始化微信配置
                    this._wechatShareSetting(shareData);
                }
            }
        }
    }
    _wechatShareSetting(shareData) {
        const _url = window.location.href;
        // 如果加载过微信JS 并且加载成功了，那就进行设置
        console.log('已经初始化过wx', window.wxSDKJSLoaded && window.wx && window.wxAPIData);
        if (window.wxSDKJSLoaded && window.wx && window.wxAPIData) {
            this._initWechartSetting(shareData);
            return;
        } else if (window.wxSDKJSLoaded) {
            // 如果加载过微信JS，但是没有加载成功，就隔200ms再次尝试设置
            setTimeout(this._initWechartSetting, 200);
            return;
        }
        window.wxSDKJSLoaded = true;
        // 加载jssdk和微信配置
        this._getScript(
            `${_url[4] == 's' ? 'https' : 'http'}://res.wx.qq.com/open/js/jweixin-1.1.0.js`,
            () => {
                jsonp(
                    `${
                        _url[4] == 's' ? 'https' : 'http'
                    }://wechat.eastmoney.com/api/WX/GetJsSdkUiPackage/1?s=${encodeURIComponent(
                        _url
                    )}`,
                    {
                        param: 'cb'
                    },
                    (error, data) => {
                        if (!error) {
                            window.wxAPIData = data;
                            this._initWechartSetting(shareData);
                        }
                    }
                );
            }
        );
    }

    _initWechartSetting(shareData) {
        if (!window.wx || !window.wxAPIData) {
            setTimeout(this._initWechartSetting, 200);
            return;
        }
        wx.config({
            debug: false,
            appId: window.wxAPIData.AppId,
            timestamp: window.wxAPIData.Timestamp,
            nonceStr: window.wxAPIData.NonceStr,
            signature: window.wxAPIData.Signature,
            jsApiList: [
                'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo'
            ]
        });
        wx.ready(function() {
            wx.onMenuShareAppMessage(shareData);
            wx.onMenuShareTimeline({
                ...shareData,
                title: `${shareData.desc.includes(shareData.title) ? '' : shareData.title} ${
                    shareData.desc
                }`
            });
            wx.onMenuShareQQ(shareData);
            wx.onMenuShareWeibo(shareData);
        });
    }

    _getScript(src, callback = () => {}) {
        const head = document.querySelector('head');
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', src);
        head.appendChild(script);
        if (document.all) {
            script.onreadystatechange = function() {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    callback();
                }
            };
        } else {
            script.onload = function() {
                callback();
            };
        }
    }

    initQQ(data) {
        var ua = navigator.userAgent;
        var isQQ = ua.match(/QQ\/([\d\.]+)/);
        if (!isQQ) return;
        var info = {
            title: data.title,
            desc: data.summary,
            share_url: data.url,
            image_url: data.pic
        };
        function doQQShare() {
            try {
                window.mqq.data.setShareInfo(info, data.callback);
            } catch (e) {
                console.log(e);
            }
        }
        if (window.mqq) {
            doQQShare();
        } else {
            this._getScript(qqapi, () => {
                doQQShare();
            });
        }
    }
}

export default Share;
